import React, { useState, useEffect } from 'react';

const ClientForm = () => {
  const [client, setClient] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    tax_id: '',
    credit_limit: '',
    account_receivable: '0',
    payment_terms: '',
    currency: ''
  });

  const [clients, setClients] = useState([]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/clients`);
        if (!response.ok) {
          throw new Error('Erreur lors de la récupération des clients');
        }
        const data = await response.json();
        setClients(data);
      } catch (error) {
        console.error('Erreur:', error);
      }
    };

    fetchClients();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setClient(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!client.name || !client.email) {
      alert('Le nom et l\'email sont obligatoires.');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/clients`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(client),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de l\'ajout du client');
      }

      const data = await response.json();
      console.log('Client ajouté:', data);

      setClients(prevClients => [...prevClients, data]);

      setClient({
        name: '',
        email: '',
        phone: '',
        address: '',
        tax_id: '',
        credit_limit: '',
        account_receivable: '0',
        payment_terms: '',
        currency: ''
      });

      alert('Client ajouté avec succès!');
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de l\'ajout du client');
    }
  };

  return (
    <div className="container">
      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="text"
            name="name"
            value={client.name}
            onChange={handleChange}
            placeholder="Nom du client"
            required
          />
        </div>
        <div>
          <input
            type="email"
            name="email"
            value={client.email}
            onChange={handleChange}
            placeholder="Email"
            required
          />
        </div>
        <div>
          <input
            type="text"
            name="phone"
            value={client.phone}
            onChange={handleChange}
            placeholder="Téléphone"
          />
        </div>
        <div>
          <textarea
            name="address"
            value={client.address}
            onChange={handleChange}
            placeholder="Adresse"
          />
        </div>
        <div>
          <input
            type="text"
            name="tax_id"
            value={client.tax_id}
            onChange={handleChange}
            placeholder="Identifiant fiscal"
          />
        </div>
        <div>
          <input
            type="number"
            name="credit_limit"
            value={client.credit_limit}
            onChange={handleChange}
            placeholder="Limite de crédit"
          />
        </div>
        <div>
          <input
            type="number"
            name="account_receivable"
            value={client.account_receivable}
            onChange={handleChange}
            placeholder="Créances"
          />
        </div>
        <div>
          <input
            type="number"
            name="payment_terms"
            value={client.payment_terms}
            onChange={handleChange}
            placeholder="Conditions de paiement (jours)"
          />
        </div>
        <div>
          <input
            type="text"
            name="currency"
            value={client.currency}
            onChange={handleChange}
            placeholder="Devise"
          />
        </div>
        <button type="submit">Ajouter le client</button>
      </form>

      <div>
        <h2>Liste des clients</h2>
        <ul>
          {clients.map((client, index) => (
            <li key={index}>
              {client.name} - {client.email} <br /> {client.phone} <br /> {client.address} <br />
              {client.tax_id} <br /> {client.credit_limit} <br /> {client.account_receivable} <br />
              {client.payment_terms} <br /> {client.currency}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ClientForm;
